<template>
  <div class="item" id="cardInfo.id">
    <div class="img-box">
      <a :href="img.id" target="_blank">
        <img :src="img.url"  :alt="img.title">
      </a>
    </div>
  </div>
</template>
<script>
  export default {
    props: [
      'img'
    ]
  }
</script>
<style scoped lang="scss">
  @import "../assets/style/mixin";

  .item {
    background-color: #FFFFFF;
    padding: 15px 5px 15px 5px;
    display: flex;
    flex-direction: column;
    position: relative;
    height: 60px;
    width: 40px;
    text-align: center;
    line-height: 60px;
    img {
      display: block;
      max-width: 30px;
    }
    :hover{

    }
    .img-box {
      @extend %block-center
    }
  }
</style>



// WEBPACK FOOTER //
// accountIcon.vue?5532c236